import gql from "/vendor/graphql-tag";

// Generic mutation that creates or updates any Sensu resource from its
// wrapped-JSON representation (the same shape sensuctl uses):
//
//   { "type": "CheckConfig", "api_version": "core/v2",
//     "metadata": { ... }, "spec": { ... } }
//
// When `upsert` is true an existing resource is overwritten, otherwise the
// mutation fails if the resource already exists.
const mutation = gql`
  mutation PutWrappedMutation($raw: String!, $upsert: Boolean) {
    putWrapped(raw: $raw, upsert: $upsert) {
      node {
        id
      }
      errors {
        input
        code
        ... on StandardError {
          message
        }
      }
    }
  }
`;

export default (client, { raw, upsert = true }) =>
  client
    .mutate({
      mutation,
      variables: { raw, upsert },
      // The affected resource may already be present in the cache under a
      // different query; refetching the owning views is handled by callers.
      fetchPolicy: "no-cache",
    })
    .then((result) => result.data.putWrapped);
